import * as React from 'react';
import { motion } from 'motion/react';
import { getVariants, useAnimateIconContext, IconWrapper } from './AnimateIcon';

const animations = {
  default: {
    handle: {},
    tip: {},
  },
  brush: {
    handle: {
      initial: { pathLength: 1, rotate: 0 },
      animate: {
        rotate: [0, -8, 8, -4, 0],
        transition: { duration: 0.5, ease: 'easeInOut' },
      },
    },
    tip: {
      initial: { pathLength: 1, opacity: 1 },
      animate: {
        pathLength: [0, 1],
        transition: { duration: 0.4, ease: 'easeOut' },
      },
    },
  },
};

function IconComponent({ size, ...props }) {
  const { controls } = useAnimateIconContext();
  const variants = getVariants(animations);

  return (
    <motion.svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <motion.path
        d="m9.06 11.9 8.07-8.06a2.85 2.85 0 1 1 4.03 4.03l-8.06 8.08"
        variants={variants.handle}
        initial="initial"
        animate={controls}
      />
      <motion.path
        d="M7.07 14.94c-1.66 0-3 1.35-3 3.02 0 1.33-2.5 1.52-2 2.02 1 1 2.72 2 6 2 2.22 0 3.5-.93 3.5-2.02 0-1.67-1.22-3.02-4.5-3.02z"
        variants={variants.tip}
        initial="initial"
        animate={controls}
      />
    </motion.svg>
  );
}

function Brush(props) {
  return <IconWrapper icon={IconComponent} {...props} />;
}

export { animations, Brush, Brush as BrushIcon };
